import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import loader from "../../../../assets/images/menu-icon/loader.gif";
import { Dispatch } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../../config/Store';
import { setAdminAgreementTab } from '../../../../reducers/AuthReducer';
import WebService, { BASE_URL } from '../../../../utility/WebService';
import Loader from '../../../../components/Loader/Loader';
import { AGREEMENT_TAB, setDataInRedux } from '../../../../actions/CommonAction';
import Pagination from '../../../../components/pagination/Pagination';
import { TbDownload, TbUpload } from 'react-icons/tb';
import SignedAgreement from './SignedAgreement';
import CompletedAgreement from './CompletedAgreement';
import SucessModal from '../../../../components/SucessModal/Sucess';
import WarningModal from '../../../../components/Warning/Warning';
import HelperService from '../../../../utility/HelperService';
import ExpiredContact from './ExpiredContact';
import BackComponent from '../../../../components/BackArrow';
import SpringMoneyPagination from '../../../../components/SpringMoney/Pagination/SpringMoneyPagination';
import { toast } from "../../../../components/AppModal/AppModal";
import '../../Masters/MasterList.css';
import { useMenuBack } from "../../../../hooks/useMenuBack";

/* ---- inline stroke icons (apv style, kept local to this screen) ---- */
const IconSearch = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
);
const IconEdit = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z" /></svg>
);
const IconDownload = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" /></svg>
);
const IconArchive = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="4" rx="1" /><path d="M5 8v11a1 1 0 001 1h12a1 1 0 001-1V8" /><path d="M10 12h4" /></svg>
);
const IconPlus = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
);
const IconArrowRight = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
);
const IconStar = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.8 6.2 21.9l1.1-6.5L2.6 10.7l6.5-.9L12 3z" /></svg>
);
const IconBack = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
);

const Agreement = () => {
  const goBack = useMenuBack();
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
    const getTab = localStorage.getItem("goToTab");
    const [openTab, setOpenTab] = React.useState(user_data.is_person == 'Employee' ? 4 : 1);
    let history = useNavigate();
    const [totalCount, setTotalCount] = useState(0);
    const [agreement, setAgreement] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const tab: any = useSelector<RootState, setAdminAgreementTab>((state) => state.adminAgreementTab);
    const dispatch: Dispatch<any> = useDispatch();
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [res, setRes] = useState<any>({});
    const [TotalPages, setTotalPages] = useState<number>();
    const [goToPageNumber, setGoToPageNumber] = useState<string>("");
    const pageSizeKey = "ml_pagesize_agreement_page_size_" + (user_data?.user_id || "default");
    const PAGE_SIZES = [10, 25, 100, 250, 500];
    const readSavedPageSize = () => {
        const v = parseInt(localStorage.getItem(pageSizeKey) || "", 10);
        return PAGE_SIZES.indexOf(v) >= 0 ? v : 100;
    };
    const [itemsCountPerPage, setItemsCountPerPage] = useState<number>(() => readSavedPageSize());
    const [defaultPageSize, setDefaultPageSize] = useState<number>(() => readSavedPageSize());

    useEffect(() => {
        const getTab = localStorage.getItem("goToTab");
        if(getTab){
            getTab == "SIGNED" && setOpenTab(2);
            getTab == "PENDING" && setOpenTab(1);
            getTab == "COMPLETED" && setOpenTab(3);
        }
        if (tab.tabName) {
            setOpenTab(tab.tabName)
        }
        getList(1);
        tabsCount();
    }, []);

    // load the user's saved default page size from their account so it follows
    // them across devices (localStorage above is just an instant local cache)
    useEffect(() => {
        WebService.getAPI({ action: `/v2/UserSetting/Get?key=agreement_page_size`, body: null })
            .then((res: any) => {
                const v = parseInt(res?.value, 10);
                if (PAGE_SIZES.indexOf(v) >= 0) {
                    setDefaultPageSize(v);
                    setItemsCountPerPage(v);
                    try { localStorage.setItem(pageSizeKey, String(v)); } catch (e) { }
                }
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        getList(currentPage);
    }, [currentPage, itemsCountPerPage]);

    const getList = (page: Number) => {
        setShowLoader(true);
        WebService.getAPI({
            action: `${user_data.is_person == 'Employee' ? `/v2/ClientAgreements/GetAgreementList` : `/v2/ClientAgreements/GetClientAgreementList`}?page=${page}&status=PENDING&keyword=${encodeURIComponent(searchText)}&limit=${itemsCountPerPage}`,
            body: null
        })
            .then((res: any) => {
                setAgreement(res.list)
                setTotalCount(res.total_count)
                setShowLoader(false);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };

    const tabsCount = () =>{
        WebService.getAPI({
            action: `/v2/ClientAgreements/GetTabsCount?person=${user_data.is_person == "Employee" ? "Employee" : "Client"}`,
            body: null
        })
            .then((res: any) => {
               setRes(res);
            })
            .catch(() => {
            });

    }

    const download = (id: any) => {
        setShowLoader(true);
        window.open(`${BASE_URL}/v2/ClientAgreements/DisplayDocument?id=${id}`)
        setShowLoader(false)
    }
    const onClickESign = (id: any) => {
        var obj: any = {}
        obj.agreement_id = id
        WebService.postAPI({
            action: `/v2/ClientAgreements/SignAadharEsign`,
            body: obj
        })
            .then((res: any) => {
                console.log(res);
                setShowLoader(true);
                window.open(`${res.url}`)
                setOpenTab(2)
                setShowLoader(false)
            })
            .catch(() => {
                setShowLoader(false);
            });
    }

    const handlePagination = (itemCount: number) => {
        setItemsCountPerPage(itemCount);
        setCurrentPage(1);
    };

    // remember the current page size for this user's next login (per-browser +
    // synced to the account so it follows the user across devices)
    const saveDefaultPageSize = () => {
        try {
            localStorage.setItem(pageSizeKey, String(itemsCountPerPage));
        } catch (e) { }
        setDefaultPageSize(itemsCountPerPage);
        WebService.postAPI({
            action: `/v2/UserSetting/Save`,
            body: { key: "agreement_page_size", value: String(itemsCountPerPage) }
        }).catch(() => { });
        toast.success(`Showing ${itemsCountPerPage} per page by default from now on.`);
    };

    const handleGoToPageInput = (e: any) => {
        if (e.key === "Enter" && goToPageNumber !== "") {
            if (TotalPages && Number(goToPageNumber) > TotalPages) {
                setCurrentPage(TotalPages);
            } else {
                setCurrentPage(Number(goToPageNumber));
            }
        }
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    };

    const agreementTypeLabel = (t: any) =>
        t === 'AADHAR_E_SIGN' ? 'Aadhar E-Sign' :
        t === 'E_SIGN' ? 'Wet Sign' :
        t === 'SCANED_BY_BOTH' ? 'Physical' : "-";

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <div className="page-content-wraper ml-page">
                <div className="ml-head">
                    <div className="ml-head-l">
                        <button type="button" className="ml-back" title="Back" onClick={() => goBack()}>
                            <IconBack />
                        </button>
                        <div>
                            <h1 className="ml-title">Agreement</h1>
                            <div className="ml-sub">MIS Report &middot; Client / employee agreements</div>
                        </div>
                    </div>
                    <div className="ml-head-r">
                        <button type="button" className="ml-btn" title="Expired Agreements" onClick={() => history(`/admin/mis-report/archived-agreement`)}>
                            <IconArchive /> Expired Agreements
                        </button>
                        {user_data.is_person == 'Employee' && openTab == 1 &&
                            <NavLink to="/admin/mis-report/add-agreement" className="ml-btn ml-btn-brand">
                                <IconPlus /> Add
                            </NavLink>
                        }
                    </div>
                </div>

                <div className="ml-tabs" role="tablist">
                    {user_data.is_person == 'Employee' &&
                        <a
                            className={"ml-tab " + (openTab === 4 ? "active" : "")}
                            onClick={e => {
                                e.preventDefault();
                                dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 4 }));
                                localStorage.setItem('openTab', "4")
                                setOpenTab(4);
                                getList(1)
                            }}
                            data-toggle="tab"
                            href="#link4"
                            role="tablist"
                        >
                            No Agreement
                            <span className="ml-tab-badge">{res.no_agreement}</span>
                        </a>
                    }
                    <a
                        className={"ml-tab " + (openTab === 1 ? "active" : "")}
                        onClick={e => {
                            e.preventDefault();
                            dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 1 }));
                            localStorage.setItem('openTab', "1")
                            setOpenTab(1);
                            getList(1)
                        }}
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                    >
                        Client&apos;s sign pending
                        <span className="ml-tab-badge">{res.pending}</span>
                    </a>
                    <a
                        className={"ml-tab " + (openTab === 2 ? "active" : "")}
                        onClick={e => {
                            e.preventDefault();
                            dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 2 }));
                            localStorage.setItem('openTab', "2")
                            setOpenTab(2);
                        }}
                        data-toggle="tab"
                        href="#link2"
                        role="tablist"
                    >
                        Advisor&apos;s sign pending
                        <span className="ml-tab-badge">{res.signed}</span>
                    </a>
                    <a
                        className={"ml-tab " + (openTab === 3 ? "active" : "")}
                        onClick={e => {
                            e.preventDefault();
                            dispatch(setDataInRedux({ type: AGREEMENT_TAB, value: 3 }));
                            localStorage.setItem('openTab', "3")
                            setOpenTab(3);
                        }}
                        data-toggle="tab"
                        href="#link2"
                        role="tablist"
                    >
                        Completed
                        <span className="ml-tab-badge">{res.completed}</span>
                    </a>
                </div>

                <div className="tab-content tab-space">
                    <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                        <div className="ml-card">
                            <div className="ml-toolbar">
                                <div className="ml-sizes">
                                    <span>Show:</span>
                                    {PAGE_SIZES.map((size) => (
                                        <button
                                            key={size}
                                            type="button"
                                            onClick={() => handlePagination(size)}
                                            className={`ml-size-btn ${itemsCountPerPage === size ? "active" : ""}`}
                                        >
                                            {size}
                                        </button>
                                    ))}
                                    <span className="ml-sizes-sep"></span>
                                    <button
                                        type="button"
                                        className="ml-setdefault"
                                        onClick={saveDefaultPageSize}
                                        disabled={itemsCountPerPage === defaultPageSize}
                                        title="Remember this page size for your next login"
                                    >
                                        <IconStar /> Set as default
                                    </button>
                                    <span className="ml-defnote">Default: {defaultPageSize}</span>
                                </div>
                                <div className="ml-tools">
                                    <div className="ml-search">
                                        <IconSearch />
                                        <input
                                            id="search"
                                            name="search"
                                            placeholder="Search"
                                            type="search"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyUp={(e) => {
                                                if (e.keyCode === 13) {
                                                    getList(0)
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="ml-tablewrap">
                                <table className="ml-table">
                                    <thead>
                                        <tr>
                                            <th>Client Name</th>
                                            <th>Agreement Type</th>
                                            <th>Agreement Start Date</th>
                                            <th>Agreement End Date</th>
                                            <th>Date</th>
                                            <th className='text-center' style={{ width: "120px" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showLoader && Array.from({ length: 8 }).map((_, i) => (
                                            <tr key={'sk-' + i} className="ml-skrow">
                                                <td><span className="ml-sk" style={{ width: "60%" }}></span></td>
                                                <td><span className="ml-sk" style={{ width: "50%" }}></span></td>
                                                <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                                <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                                <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                                <td className="text-center"><span className="ml-sk ml-sk-pill" style={{ width: "64px", margin: "0 auto" }}></span></td>
                                            </tr>
                                        ))}
                                        {!showLoader && agreement?.length > 0 && agreement.map((res, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="ml-name">{res.client_name ? res.client_name : "-"}</td>
                                                    <td>{agreementTypeLabel(res.agreement_type)}</td>
                                                    <td>{res.start_date ? HelperService.getFormatedDateByDMY(res.start_date) : "-"}</td>
                                                    <td>{res.end_date ? HelperService.getFormatedDateByDMY(res.end_date) : "Perpetual"}</td>
                                                    <td>{res.created_at ? HelperService.getFormatedDateByDMY(res.created_at) : "-"}</td>
                                                    {user_data.is_person == 'Client' &&
                                                        <td className='text-center'>
                                                            <div className="ml-actions">
                                                                {res.agreement_type == 'AADHAR_E_SIGN' &&
                                                                    <button type="button" title="Sign" className="ml-btn ml-btn-brand" onClick={() => onClickESign(res.id)}>
                                                                        Sign</button>
                                                                }
                                                                {res.agreement_type != 'AADHAR_E_SIGN' &&
                                                                    <button type="button" title="Upload Signed Document" className="ml-btn ml-btn-brand" onClick={() => history(`/admin/mis-report/upload-agreement/${res.id}`)}>
                                                                        Sign</button>
                                                                }
                                                                <button type="button" className="ml-act blue" title="Download" onClick={() => download(res.id)}>
                                                                    <IconDownload />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    }
                                                    {user_data.is_person == 'Employee' &&
                                                        <td className='text-center'>
                                                            <div className="ml-actions">
                                                                <button type="button" className="ml-act blue" title="Download" onClick={() => download(res.id)}>
                                                                    <IconDownload />
                                                                </button>
                                                                <button type="button" className="ml-act blue" title="Edit" onClick={() => history(`/admin/mis-report/edit-agreement/${res.client_id}/${res.id}`, {
                                                                    state: {
                                                                        name: res.client_name
                                                                    }
                                                                })}>
                                                                    <IconEdit />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {agreement?.length == 0 && showLoader == false &&
                                <div className="ml-empty">
                                    <div className="ml-empty-ic">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="11" cy="11" r="7" />
                                            <path d="M21 21l-4.3-4.3" />
                                        </svg>
                                    </div>
                                    <h2>No Records Found</h2>
                                    <p>Try a different search term.</p>
                                </div>
                            }

                            {totalCount > 0 &&
                                <div className="ml-pager">
                                    <div className="ml-total">Total count: <b>{totalCount}</b></div>
                                    <div>
                                        <SpringMoneyPagination
                                            currentPageNo={currentPage}
                                            setCurrentPageNo={setCurrentPage}
                                            itemsCountPerPage={itemsCountPerPage}
                                            totalItems={totalCount}
                                            TotalPages={TotalPages}
                                            setTotalPages={setTotalPages}
                                        />
                                    </div>
                                    <div className="ml-goto">
                                        <span>Go to page</span>
                                        <input
                                            onKeyDown={handleGoToPageInput}
                                            type="number"
                                            value={goToPageNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^[1-9]\d*$/.test(value) || value === "") {
                                                    setGoToPageNumber(value);
                                                }
                                            }}
                                        />
                                        <a title="Next" onClick={() => {
                                            if (goToPageNumber !== "") {
                                                if (TotalPages && (Number(goToPageNumber) > TotalPages)) {
                                                    setCurrentPage(TotalPages);
                                                } else {
                                                    setCurrentPage(Number(goToPageNumber));
                                                }
                                            }
                                        }}>
                                            <IconArrowRight />
                                        </a>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {openTab == 2 && <SignedAgreement />}
                    {openTab == 3 && <CompletedAgreement />}
                    {openTab == 4 && <ExpiredContact />}

                </div>
            </div>
        </>
    );
};
export default Agreement;
